import { InfoB, InfoBoxStyle, InfoBoxType, InfoBoxWidth } from '@app/models/infobox';

export class InfoBoxUtilities {

  public static getStyleClasses(box: InfoB) {
    switch (box.Style) {
      case InfoBoxStyle.None:
        return box.Type !== InfoBoxType.Text ? 'picvid-style-1' : 'text-style-1';
      case InfoBoxStyle.Accent1:
       return box.Type !== InfoBoxType.Text ? 'picvid-style-2' : 'text-style-2';
      case InfoBoxStyle.Accent2:
       return box.Type !== InfoBoxType.Text ? 'picvid-style-3' : 'text-style-3';
      case InfoBoxStyle.Accent3:
       return box.Type !== InfoBoxType.Text ? 'picvid-style-4' : 'text-style-4';
      default:
       return box.Type !== InfoBoxType.Text ? 'picvid-style-1' : 'text-style-1';
    }
  }

  public static getWidthClasses(box: InfoB) {
    switch (box.Width) {
      case InfoBoxWidth.Auto:
        return 'w-auto';
      case InfoBoxWidth.Width100Percent:
        return 'w-100';
      case InfoBoxWidth.Width75Percent:
        return 'w-75';
      case InfoBoxWidth.Width66Percent:
        return 'w-66';
      case InfoBoxWidth.Width50Percent:
        return 'w-50';
      case InfoBoxWidth.Width33Percent:
        return 'w-33';
      case InfoBoxWidth.Width25Percent:
        return 'w-25';
      default:
        return 'w-auto';
    }
  }

  public static getCustomStyle(box: InfoB) {
    let bgStyle;
    let textStyle;
    if (box.CustomBackgroundColorHexCode) {
      bgStyle = { 'background-color': box.CustomBackgroundColorHexCode };
    }
    if (box.CustomTextColorHexCode) {
      textStyle = { 'color': box.CustomTextColorHexCode };
    }
    return {...bgStyle, ...textStyle};
  }
}
